module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Thunder-circle-af9fdb8d8597e50477dc2c9347964038.svg";